<template>
  <div
    class="flex flex-row items-center cursor-pointer hover:bg-gray-100 duration-300 transition p-2 mr-2 rounded leading-none relative"
    @mouseenter.stop="sendHoverEnter"
    @mouseleave.stop="sendHoverLeave"
  >
    <img
      :src="require(`@/assets/images/wonder/${wonder.icon}`)"
      alt=""
      class="w-8 h-8"
    >
    <div class="ml-2 flex flex-col">
      <span class="text-sm leading-none uppercase font-medium">
        {{ wonder.name }}
      </span>
      <KindName
        :kind="wonder.kind"
        :kindMultiplier="wonder.kindMultiplier"
        class="mt-1"
      />
    </div>
    <AlliedCultureCrest
      class="absolute top-0.5 -left-1"
      :wonder="wonder"
    />
    <div class="flex-grow text-right flex flex-row items-center ml-8">
      <span class="flex-grow"/>
      <WonderLevel
        :last="last"
        :level="config.level"
        :wonder="wonder"
        @level="changeLevel"
      />
      <WonderActivation
        :active="config.active"
        :wonder="wonder"
        :wonder-count="activeWonderCount"
        @activate="toggleWonderActive"
      />
    </div>
  </div>
</template>

<script>
import KindName from "@/components/Wonders/KindName.vue";
import AlliedCultureCrest from "@/components/Wonders/AlliedCultureCrest.vue";
import WonderLevel from "@/components/Wonders/WonderLevel.vue";
import WonderActivation from "@/components/Wonders/WonderActivation.vue";

export default {
  components: {
    KindName,
    AlliedCultureCrest,
    WonderLevel,
    WonderActivation
  },
  props: {
    wonder: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    activeWonderCount: {
      type: Number,
      required: true
    },
    last: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    return {
      changeLevel(level, id) {
        context.emit('level', level, id);
      },
      toggleWonderActive(id) {
        context.emit('activate', id);
      },
      sendHoverEnter() {
        context.emit('hover', props.wonder.id);
      },
      sendHoverLeave() {
        context.emit('hover', null);
      }
    };
  }
};
</script>
